export const MODAL_TYPE_LOGIN = 'login';
export const MODAL_TYPE_JOIN = 'join';
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 72;
